import React from 'react';
import { XIcon } from 'lucide-react';
const pains = ['Staring at a blank clipboard the night before, with no idea what to run', 'Half the team standing around while a few kids take reps', 'Drills with no clear order, so you guess what comes after what', 'Showing up and making it up on the spot, every single week', 'Volunteering with zero coaching background and feeling exposed in front of the kids', 'Parents watching, wondering if you actually know what you’re doing', 'Scrolling YouTube at 10pm looking for drills you can actually teach', 'A rainout or half the team missing, and no plan B'];
export function PainGrid() {
  return <section aria-labelledby="pain-heading" className="w-full bg-navy-deep" data-id="element-155" data-mp="1brxcep9xnng2">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-156" data-mp="17qc3ff0irtb5">
        <div className="text-center" data-id="element-157" data-mp="362u90ibkvos4">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-158" data-mp="361rg64up3c9k">
            The coaching reality
          </p>
          <h2 id="pain-heading" className="chalk-underline mt-3 font-display font-bold uppercase text-white text-3xl sm:text-4xl md:text-5xl leading-tight" data-id="element-159" data-mp="3g8k47hzo2kro">
            If you coach youth baseball, you know at least{' '}
            <span className="text-clay-soft" data-id="element-160" data-mp="37a87qzc4csrb">half of this list.</span>
          </h2>
        </div>

        <ul className="mt-9 grid gap-3 text-left sm:grid-cols-2 sm:gap-x-5" data-id="element-161" data-mp="3baa7v427he4h">
          {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-xl border border-navy-line bg-navy-card px-4 py-4 text-sm text-white/85" data-id="element-162" data-mp="2wjen1hn7hog">
              <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-crimson/20" data-id="element-163" data-mp="3q70zus9jvnk2">
                <XIcon className="h-3 w-3 text-crimson-soft" aria-hidden="true" data-id="element-164" data-mp="3u6i5pmsw2mpr" />
              </span>
              {pain}
            </li>)}
        </ul>

        <p className="chalk-note mt-9 text-center text-3xl sm:text-4xl text-gold leading-tight" data-id="element-165" data-mp="10fhxo65kfdm8">
          How many more practices do you want to improvise?
        </p>
      </div>
    </section>;
}